import _asyncToGenerator from "/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { uniqueId } from 'lodash'; // 设置文件

import setting from '@/settings.js';
import { fetchRoleMenus } from '@api/u8.api.menu';
import u8Layout from '@/views/layout'; // 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载

var _import = require('@/libs/util.import.' + process.env.NODE_ENV);

import router from '@/router';
var meta = {
  auth: true
};
/**
 * 给菜单数据补充上 path 字段
 */

function supplementMenuPath(menu) {
  return menu.map(function (e) {
    return _objectSpread(_objectSpread({}, e), {}, {
      path: e.path || uniqueId('u8-menu-empty-')
    }, e.children ? {
      children: supplementMenuPath(e.children)
    } : {});
  });
}

export default {
  namespaced: true,
  state: {
    // 顶栏菜单
    header: [],
    // 侧栏菜单
    sidebar: [],
    // 侧边栏收缩
    collapse: setting.menu.sidebarCollapse
  },
  actions: {
    /**
     * 根据菜单更新路由
     */
    updateRoutes: function updateRoutes(_ref, menus) {
      var state = _ref.state,
          dispatch = _ref.dispatch;

      if (!menus || menus.length === 0) {
        console.log("there is no menus. don't need update routes");
        return;
      }

      var route = {
        path: '/u8sdk',
        name: 'u8sdk',
        component: u8Layout,
        children: []
      };

      var _iterator = _createForOfIteratorHelper(menus),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var parent = _step.value;

          if (!parent.children || parent.children.length === 0) {// route.children.push({path: '/'+parent.path, name: parent.path, component: _import(parent.path), meta: { ...meta }})
          } else {
            var _iterator2 = _createForOfIteratorHelper(parent.children),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var child = _step2.value;

                if (child.path == 'u8sdk/setting/global') {
                  route.children.push({
                    path: '/' + child.path,
                    name: child.path,
                    component: _import(child.path),
                    meta: _objectSpread(_objectSpread({}, meta), {}, {
                      title: child.name,
                      steps: [parent.name],
                      breadcrumb: 0
                    })
                  });
                } else {
                  route.children.push({
                    path: '/' + child.path,
                    name: child.path,
                    component: _import(child.path),
                    meta: _objectSpread(_objectSpread({}, meta), {}, {
                      title: child.name,
                      steps: [parent.name]
                    })
                  });
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      router.addRoutes([route, {
        path: '*',
        name: '404',
        component: _import('system/error/404')
      }]);
    },
    fetchMenus: function fetchMenus(_ref2) {
      var state = _ref2.state,
          dispatch = _ref2.dispatch,
          rootGetters = _ref2.rootGetters;
      return new Promise( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resolve, reject) {
          var userInfo;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  userInfo = rootGetters['u8sdk/user/currUserInfo'];

                  if (!(!userInfo || !userInfo.roleId)) {
                    _context2.next = 4;
                    break;
                  }

                  dispatch('u8sdk/account/logout', {}, {
                    root: true
                  });
                  return _context2.abrupt("return");

                case 4:
                  // 请求协议，获取菜单
                  fetchRoleMenus({
                    adminRoleID: userInfo.roleId
                  }).then( /*#__PURE__*/function () {
                    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
                      return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              dispatch('updateRoutes', res);
                              state.sidebar = res;
                              resolve();

                            case 3:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    return function (_x3) {
                      return _ref4.apply(this, arguments);
                    };
                  }()).catch(function (err) {
                    console.log('fetchRoleMenus err', err);
                    reject(err);
                  });

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x, _x2) {
          return _ref3.apply(this, arguments);
        };
      }());
    },

    /**
     * 设置侧边栏展开或者收缩
     * @param {Object} context
     * @param {Boolean} collapse is collapse
     */
    collapseSet: function collapseSet(_ref5, collapse) {
      var state = _ref5.state,
          dispatch = _ref5.dispatch;
      return new Promise( /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(resolve) {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  // store 赋值
                  state.collapse = collapse; // 持久化

                  _context3.next = 3;
                  return dispatch('u8sdk/db/set', {
                    dbName: 'sys',
                    path: 'menu.sidebar.collapse',
                    value: state.collapse,
                    user: true
                  }, {
                    root: true
                  });

                case 3:
                  // end
                  resolve();

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x4) {
          return _ref6.apply(this, arguments);
        };
      }());
    },

    /**
     * 切换侧边栏展开和收缩
     * @param {Object} context
     */
    collapseToggle: function collapseToggle(_ref7) {
      var state = _ref7.state,
          dispatch = _ref7.dispatch;
      return new Promise( /*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(resolve) {
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  // store 赋值
                  state.collapse = !state.collapse; // 持久化

                  _context4.next = 3;
                  return dispatch('u8sdk/db/set', {
                    dbName: 'sys',
                    path: 'menu.sidebar.collapse',
                    value: state.collapse,
                    user: true
                  }, {
                    root: true
                  });

                case 3:
                  // end
                  resolve();

                case 4:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x5) {
          return _ref8.apply(this, arguments);
        };
      }());
    },

    /**
     * 从持久化数据读取侧边栏展开或者收缩
     * @param {Object} context
     */
    collapseLoad: function collapseLoad(_ref9) {
      var state = _ref9.state,
          dispatch = _ref9.dispatch;
      return new Promise( /*#__PURE__*/function () {
        var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(resolve) {
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return dispatch('u8sdk/db/get', {
                    dbName: 'sys',
                    path: 'menu.sidebar.collapse',
                    defaultValue: setting.menu.sidebarCollapse,
                    user: true
                  }, {
                    root: true
                  });

                case 2:
                  state.collapse = _context5.sent;
                  // end
                  resolve();

                case 4:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x6) {
          return _ref10.apply(this, arguments);
        };
      }());
    }
  },
  mutations: {
    /**
     * @description 设置顶栏菜单
     * @param {Object} state state
     * @param {Array} menu menu setting
     */
    headerSet: function headerSet(state, menu) {
      // store 赋值
      state.header = supplementMenuPath(menu);
    },

    /**
     * @description 设置侧边栏菜单
     * @param {Object} state state
     * @param {Array} menu menu setting
     */
    sidebarSet: function sidebarSet(state, menu) {
      // store 赋值
      state.sidebar = supplementMenuPath(menu);
    }
  }
};